import React, { Component } from 'react';

import classes from './Page.module.css';

export default class Page extends Component {
  render () {
    return <div className={classes.Page}>{this.props.children}</div>
  }
}